import styled, { css } from 'styled-components';

type OverlayProps = {
  visible: boolean;
  isFull?: boolean;
  scrollable?: boolean;
  conclusion?: boolean;
  isMainNavigation?: boolean;
  withoutPaddingHeaderDesktop?: boolean;
};

export const Content = styled.div`
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
`;

const OverlayModifier = {
  conclusion: () => css``
};

export const Overlay = styled.div<OverlayProps>`
  ${({ visible, isFull, conclusion, isMainNavigation, theme }) => css`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background: #00000066;
    z-index: 50;
    opacity: ${visible ? 1 : 0};
    pointer-events: ${visible ? 'all' : 'none'};
    transition: opacity 250ms ease-in-out;
    overflow: hidden;
    ${conclusion && OverlayModifier.conclusion()}

    @media(max-width: 900px) {
      ${isMainNavigation &&
      css`
        z-index: ${theme.layers.base};
      `}
    }
  `}
`;

const SidebarModifier = {
  isFull: (visible: boolean) => css`
    left: 0;
    right: 0;
    max-width: initial;
  `
};

export const Sidebar = styled.div<OverlayProps>`
  ${({ visible, isFull, scrollable, conclusion, isMainNavigation, theme, withoutPaddingHeaderDesktop }) => css`
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    background: #fff;
    transition: transform 250ms ease-in-out;
    z-index: 100;
    height: 100vh;
    max-width: 422px;
    width: 100%;
    overflow: hidden;
    transform: ${visible ? 'translateX(0)' : 'translateX(100vw)'};
    box-shadow: ${visible ? '-8px 0px 24px #00000029' : 'none'};
    ${scrollable && 'overflow-y: auto;'}

    * {
      font-family: 'Montserrat', sans-serif;
    }

    ${isFull && SidebarModifier.isFull(visible)}

    @media (max-width: 900px) {
      ${isMainNavigation &&
      css`
        padding-top: ${withoutPaddingHeaderDesktop ? '0' : '72px'};
        z-index: ${theme.layers.base};
      `}
    }
  `}
`;
